import { IApiParametersValues, IChangeRequest, IReservationIdFormValues, IReservationApiResponse, ITopic, IPinCheckResponse, IAdminSettingsResponse } from './interfaces';
import {  getEpochFromDate } from './utils/utils';
import { authorizedFetch } from 'abu-common-components';
import { serviceConstants} from './utils/contants';


const getCsAgentBookingReservationDetailsApi = process.env
  .REACT_APP_GET_CS_AGENT_RESERVATION_BOOKING_DETAILS_API as string;

export const readBookingAdminToolSettings = async (): Promise<IAdminSettingsResponse | string> => {
  const response = await authorizedFetch(process.env.REACT_APP_ADMIN_READ_SETTINGS as string, {
    method: 'GET',
    skipAuth: true
  });
  if (!response.ok || response.data === null) {
    return 'Failed to fetch';
  }
  return response.data as IAdminSettingsResponse;
};

const getCsTopics = process.env.REACT_APP_GET_CS_AGENT_REQUESTS_API as string;
const postRequest = process.env.REACT_APP_GET_CS_AGENT_REQUESTS_CREATE_API as string;
const postCheckReservationPin = process.env.REACT_APP_POST_CS_AGENT_CHECK_PIN_API as string;
export const getCsAgentBookingReservationDetails = async (values: IApiParametersValues) => {
  return authorizedFetch<IReservationApiResponse>(getCsAgentBookingReservationDetailsApi, {
    method: 'POST',
    body: JSON.stringify({
      reservationId: values.reservationId.toString().replace(/\s/g, '').replace(/\./g, ''),
      bookerLastName: values.lastName,
      bookerFirstName: values.firstName,
      checkinDate: values.checkInDate && getEpochFromDate(new Date(values.checkInDate)),
      checkoutDate: values.checkOutDate && getEpochFromDate(new Date(values.checkOutDate)),
      hotelId: values.hotelId,
      bookerEmail: values.emailAddress,
      pageNumber: values.pageNumber,
      sortOrder: values.sortOrder,
      sortField: values.sortField,
      pageLimit: values.pageLimit
    }),
    tokenKey: serviceConstants.OKTA_TOKEN_KEY
  });
};

export const getReservationDetailsByReservationId = async (values: IReservationIdFormValues) => {
  return authorizedFetch<IReservationApiResponse>(getCsAgentBookingReservationDetailsApi, {
    method: 'POST',
    body: JSON.stringify({
      reservationId: values.reservationId.toString().replace(/\s/g, '').replace(/\./g, ''),
      bookerEmail: values.bookerEmail
    }),
    tokenKey: serviceConstants.OKTA_TOKEN_KEY
  });
};

export const getTopics = async (): Promise<ITopic[]> => {
  const response = await authorizedFetch<ITopic[]>(getCsTopics, {
    method: 'GET',
    tokenKey: serviceConstants.OKTA_TOKEN_KEY
  });
  if (!response.ok) {
    throw new Error(response.error || 'Request failed');
  }
  return response.data || [];
};

export const createRequest = async (
  reservationID: string,
  changeRequest: IChangeRequest,
  pinNumber: string
) => {
  return authorizedFetch<ITopic[]>(postRequest, {
    method: 'POST',
    body: JSON.stringify({
      reservationId: reservationID,
      topic: changeRequest.topic,
      subtopic: changeRequest.subtopic,
      reqDetails: changeRequest.reqDetails,
      pinCode: pinNumber
    }),
    tokenKey: serviceConstants.OKTA_TOKEN_KEY
  });
};

export const updateRequest = async (changeRequest: IChangeRequest, pinNumber: string) => {
  return authorizedFetch<ITopic[]>(
    `${postRequest}/${changeRequest.reservationId}/${changeRequest.requestId}`,
    {
      method: 'PUT',
      body: JSON.stringify({
        requestId: changeRequest.requestId,
        reservationId: changeRequest.reservationId,
        topic: changeRequest.topic,
        subtopic: changeRequest.subtopic,
        reqDetails: changeRequest.reqDetails,
        pinCode: pinNumber
      }),
      tokenKey: serviceConstants.OKTA_TOKEN_KEY
    }
  );
};

export const getChangeRequests = async (reservationID: string): Promise<IChangeRequest[]> => {
  const response = await authorizedFetch<IChangeRequest[]>(`${postRequest}/${reservationID}`, {
    method: 'GET',
    tokenKey: serviceConstants.OKTA_TOKEN_KEY
  });
  if (!response.ok) {
    throw new Error(response.error || 'Request failed');
  }
  return response.data || [];
};

export const checkReservationPin = async (reservationId: string, pinNumber: string) => {
  return authorizedFetch<IPinCheckResponse>(postCheckReservationPin, {
    method: 'POST',
    body: JSON.stringify({
      reservationId: reservationId,
      pinCode: pinNumber
    }),
    tokenKey: serviceConstants.OKTA_TOKEN_KEY
  });
};
